export default "assets/images/icons/marker-71896332.svg";